import 'bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";

import '../styles/main.scss';

import logo_img from '../assets/imgs/logo.jpg'
import patrocinio_img from '../assets/imgs/patrocinio.png'
import header_img from '../assets/imgs/header.png'
import fundo_img from '../assets/imgs/fundo.png'

$(document).ready(function() {
    document.body.style.backgroundImage = 'url("' + fundo_img + '")';
});



window.APP_ASSETS = {
    'logo': logo_img,
    'patrocinio': patrocinio_img,
    'header': header_img
};
